// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__4ZEdA","gfeWrapper":"CalendarEvent_gfeWrapper__M1NG_"};